async function streamTransform(
  data: Uint8Array,
  transform: 'gzip' | 'deflate',
  mode: 'compress' | 'decompress',
): Promise<Uint8Array> {
  const stream = new Blob([data as BlobPart]).stream();
  const piped = mode === 'compress'
    ? stream.pipeThrough(new CompressionStream(transform))
    : stream.pipeThrough(new DecompressionStream(transform));
  const chunks: Uint8Array[] = [];
  const reader = piped.getReader();
  let total = 0;
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    chunks.push(value);
    total += value.length;
  }
  const out = new Uint8Array(total);
  let off = 0;
  for (const c of chunks) {
    out.set(c, off);
    off += c.length;
  }
  return out;
}

export function gzipCompress(data: Uint8Array): Promise<Uint8Array> {
  return streamTransform(data, 'gzip', 'compress');
}

export function gzipDecompress(data: Uint8Array): Promise<Uint8Array> {
  return streamTransform(data, 'gzip', 'decompress');
}
